module.exports = __webpack_public_path__ + "static/media/icon.4a66ef0e.svg";